export const AppConfig = {
    brand_text: '开发者管理台-联盾智控',
    logo_light: 'assets/img/blinker-light-60.png',
    logo_dark: 'assets/img/blinker-light-60.png',
    favicon: 'assets/img/favicon.png',
    footer_text: '',
    footer_text2: '',
    footer_about_text: '开发者管理台-联盾智控',
    main_url: 'https://admin.union-shield.com',
    sso_url: 'https://sso.union-shield.com',
    admin_url: 'https://admin.union-shield.com',
    ICON_FILE: "https://iot.union-shield.com/public/icon.json",
    i18n: {
        enable: true,
        default: '简体中文'
    }
}

//可用的图片文件名
export const ImageList = [
    'unknown',
    'diyarduino', 'arduino-red',
    'wifiduino', 'wifiduino-blue', 'esp32',
    'diylinux', 'raspberrypi-blue', 'raspberrypi-zero',
    'linux-logo', 'raspberrypi-logo',
    'ownplug', 'ownairdetector',
    'plant1', 'plant2', 'plant3', 'fan', 'humidifier', 'heater', 'hygrothermograph', 'airconditioner',
    'warninglight', 'ownbulb', 'ownlight', 'ownlight2', 'ownlight3', 'ownlight4',
    'cat', 'cathouse', 'catfood', 'dog', 'doghouse', 'dogfood', 'fishtank', 'birdcage', 'station', 'openjumperfeeder'
]